import { Flex, GridItem, Text } from '@chakra-ui/react';

interface Props {
  title?: string;
  description?: string;
}

const NoSearchResultFound = ({
  title = 'No search results',
  description = "Your current filters didn't find any results. Try updating or removing some filters and search again."
}: Props) => {
  return (
    <GridItem colSpan={12}>
      <Flex
        flexDirection="column"
        marginX={24}
        marginY={0}
        gap={2}
        paddingX={4}
        paddingY={8}
        textAlign="center"
      >
        <Text textStyle="headingGroup">{title}</Text>
        <Text textStyle="textBody" paddingX={2}>
          {description}
        </Text>
      </Flex>
    </GridItem>
  );
};

export default NoSearchResultFound;
